import Masthead from "@/pages/home/components/Masthead";
import Hero from "@/pages/home/components/Hero";
import Progress from "@/pages/home/components/Progress";
import FollowGrid from "@/pages/home/components/FollowGrid";
import Briefing from "@/pages/home/components/Briefing";
import Subscribe from "@/pages/home/components/Subscribe";
import Method from "@/pages/home/components/Method";
import Faq from "@/pages/home/components/Faq";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div id="top" className="shell min-h-screen">
      <Masthead />
      <main>
        <Hero />
        <Progress />
        <FollowGrid />
        <Briefing />
        <Subscribe />
        <Method />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}